import { $$ } from 'utils/dom';
import Lightbox from 'modules/Lightbox/Lightbox';

const imageAlbums = $$('.image-album__list');

// https://css-tricks.com/making-a-masonry-layout-that-works-today/

if (imageAlbums.length) {
  imageAlbums.forEach(async container => {
    if (isMasonrySupported(container)) return;

    const colGap = parseFloat(getComputedStyle(container).columnGap);
    const items = getChildren(container);

    container.style.gridAutoRows = '0px';
    container.style.setProperty('row-gap', '1px', 'important');

    try {
      await Promise.all([areImagesLoaded(container)]);
    } catch (e) {}

    layout({ colGap, items });

    const observer = new ResizeObserver(observerFn);
    observer.observe(container);

    function observerFn(entries) {
      // eslint-disable-next-line no-unused-vars
      for (const entry of entries) {
        layout({ colGap, items });
      }
    }
  });

  function isMasonrySupported(container) {
    if (typeof window === 'undefined') return;
    return getComputedStyle(container).gridTemplateRows === 'masonry';
  }

  function getChildren(container) {
    const children = container.children;
    return Array.from(children);
  }

  async function areImagesLoaded(container) {
    const images = Array.from(container.querySelectorAll('img'));
    const promises = images.map(img => {
      return new Promise((resolve, reject) => {
        if (img.complete) return resolve();
        img.onload = resolve;
        img.onerror = reject;
      });
    });
    return Promise.all(promises);
  }

  async function layout({ colGap, items }) {
    items.forEach(item => {
      const ib = item.getBoundingClientRect();
      item.style.gridRowEnd = `span ${Math.round(ib.height + colGap)}`;
    });
  }
}

const lightboxes = $$('.image-album__item');

if (lightboxes.length) {
  lightboxes.forEach(box => {
    new Lightbox(box, {
      selector: '.lightbox-toggle',
    }).init();
  });
}
